<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>

    export default {
        name: 'App',
    }
</script>

<style>
    @import "./assets/less/main.less";
</style>



// WEBPACK FOOTER //
// src/App.vue